export const textFieldStyle = {
  '& .MuiInputBase-input::placeholder': {
    color: 'black',
    fontSize: '1rem',
    fontWeight: '600'
  },
  '& .MuiInputLabel-root': {
    height: '21px',
    paddingTop: '22px',
    color: '#000000'

  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#000000',
    borderColor: 'grey'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none' // Remove default border
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none' // Remove hover effect
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none' // Remove focus animation
    }
  },
  '& .MuiOutlinedInput-root.Mui-error': {
    borderRadius: '12px',
    height: '51px',
    '& fieldset': {
      borderColor: 'red',
      backgroundColor: '#ffeeee',
      background: '#ffeeee',
      transition: '0.3s ease-in-out'
    }
  },
  //   '&:hover fieldset': {
  //     borderColor: 'red',
  //     backgroundColor: '#ffeeee',
  //     background: '#ffeeee',
  //     transition: '0.3s ease-in-out'
  //   },
  //   '&.Mui-focused fieldset': {
  //     borderColor: 'red',
  //     backgroundColor: '#ffeeee',
  //     background: '#ffeeee',
  //     transition: '0.3s ease-in-out'
  //   }
  // },

  'input:-webkit-autofill': {
    WebkitBoxShadow: '0 0 0 50px #FFF inset !important'
  },
  'input:-webkit-autofill:hover': {
    WebkitBoxShadow: '0 0 0 50px #FFF inset !important'
  },
  'input:-webkit-autofill:focus': {
    WebkitBoxShadow: '0 0 0 50px #FFF inset !important'
  },
  'input:-webkit-autofill:active': {
    WebkitBoxShadow: '0 0 0 50px #FFF inset !important'
  }
}
